/**
 *
 * @type {{namePlural: *, name: *, unece: string}[]}
 */
const units = require('./units')

class Unit {

    unece;
    name;
    namePlural;

    constructor(unece, name, translationService) {
        const supportedUnit = units.find((unitsOfMeasurementEntry) => unece === unitsOfMeasurementEntry.unece);
        this.unece = unece;
        if(supportedUnit) {
            this.name = translationService.translate(supportedUnit.name);
            this.namePlural = translationService.translate(supportedUnit.namePlural);
        } else {
            if(name) {
                this.name = name;
            } else {
                this.name = unece;
            }
            this.namePlural = this.name;
        }
    }

    getNameByQuantity(quantity = 1) {
        return quantity === 1 ? this.name : this.namePlural
    }
}

module.exports.Unit = Unit;